import { atom } from "jotai";
import { PortalPreferences } from "./type";

const initialValue: PortalPreferences = {
  login_type: "OTP",
};

export const portalPreferencesAtom = atom(initialValue);
